import { render } from "./nodata.vue?vue&type=template&id=bdc307a6&scoped=true&ts=true"
import script from "./nodata.vue?vue&type=script&lang=ts"
export * from "./nodata.vue?vue&type=script&lang=ts"

import "./nodata.vue?vue&type=style&index=0&id=bdc307a6&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc307a6"]])

export default __exports__